import { render, staticRenderFns } from "./DownloadAppPop.vue?vue&type=template&id=35a90b7d&scoped=true&"
import script from "./DownloadAppPop.vue?vue&type=script&lang=js&"
export * from "./DownloadAppPop.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAppPop.vue?vue&type=style&index=0&id=35a90b7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a90b7d",
  null
  
)

export default component.exports